import { useEffect, useState } from "react";

export default function BoardFundraisingResponseEditor({ client, userId }) {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    setEdit(null); setMessage(""); setError("");
    client.get(`/admin/board-fundraising/customers/${encodeURIComponent(userId)}/individual-responses`)
      .then(r => setRows(r.data.responses)).catch(() => setError("Individual responses could not be loaded."));
  }, [client, userId]);
  const save = async e => {
    e.preventDefault(); setBusy(true); setError("");
    try {
      await client.put(`/admin/board-fundraising/customers/${encodeURIComponent(userId)}/individual-responses/${edit.response_id}`,
        { original_answers: edit.original_answers, involvement: edit.involvement });
      setRows(current => current.map(row => row.response_id === edit.response_id ? edit : row));
      setEdit(null); setMessage("Individual response saved. Agreed Group Game decisions and adopted strategies retain their existing records.");
    } catch (err) { setError(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "The response could not be saved."); }
    finally { setBusy(false); }
  };
  return <div className="bf-admin-live-panel"><h3>Assist with individual fundraising responses</h3>
    <select value={edit?.response_id || ""} onChange={e => setEdit(rows.find(row => row.response_id === e.target.value) || null)}>
      <option value="">Choose a participant</option>{rows.map(row => <option key={row.response_id} value={row.response_id}>{row.name}</option>)}
    </select>
    {edit && <form className="bf-admin-event-form" onSubmit={save}>
      {["1", "2", "3", "4", "5"].map(key => <label key={key}>Original answer {key}<textarea required maxLength={6000} value={edit.original_answers?.[key] || ""}
        onChange={e => setEdit({ ...edit, original_answers: { ...edit.original_answers, [key]: e.target.value } })}/></label>)}
      <label>Participation<textarea required maxLength={6000} value={edit.involvement || ""} onChange={e => setEdit({ ...edit, involvement: e.target.value })}/></label>
      <button className="button" disabled={busy}>Save assisted response</button>
    </form>}
    {message && <p role="status">{message}</p>}{error && <p role="alert">{error}</p>}
  </div>;
}
